function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.86 10.241L12.944 1.334a1.508 1.508 0 00-1.893 0L.138 10.241a.375.375 0 00-.054.527l.473.582a.375.375 0 00.525.056L2.998 9.84v11.391a.75.75 0 00.75.75h6a.75.75 0 00.75-.75v-6l3.001.014v6.004a.75.75 0 00.75.75l6.001-.015a.75.75 0 00.75-.75V9.84l1.916 1.565a.375.375 0 00.527-.055l.473-.582a.374.374 0 00-.056-.528zm-4.365 10.247h.004l-4.5.014v-6.008a.752.752 0 00-.748-.75l-4.5-.013a.751.751 0 00-.753.75v6.007h-4.5V8.617l7.5-6.121 7.502 6.12-.005 11.872z",
  fill: "#fff"
});
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgHome;